export default {
  path: '/2019CQYFJ',
  name: '2019CQYFJ',
  component: () => import('./home.vue'),
  redirect: '/2019CQYFJ/FirstPage',
  base: '/2019CQYFJ/',
  meta: {
    title: '重庆药房100强品牌推介活动',
  },
  children: [
    {
      path: 'FirstPage',
      component: () => import('./FirstPage.vue'),
      name: '2019CQYFJ',
      meta: {
        title: '重庆药房100强品牌推介活动',
      },
    },
    {
      path: 'List',
      component: () => import('./List.vue'),
      name: '2019CQYFJ',
      meta: {
        title: '重庆药房100强品牌推介活动',
      },
    },
    {
      path: 'Register',
      component: () => import('./Register.vue'),
      name: '2019CQYFJ',
      meta: {
        title: '重庆药房100强品牌推介活动',
      },
    },
    {
      path: 'DetailPage',
      component: () => import('./DetailPage.vue'),
      name: '2019CQYFJ',
      meta: {
        title: '重庆药房100强品牌推介活动',
      },
    },
    {
      path: 'Rules',
      component: () => import('./Rules.vue'),
      name: '2019CQYFJ',
      meta: {
        title: '重庆药房100强品牌推介活动',
      },
    },
    {
      path: 'NewsPage',
      component: () => import('./NewsPage.vue'),
      name: '2019CQYFJ',
      meta: {
        title: '重庆药房100强品牌推介活动',
      },
    },
    {
      path: 'Recommend',
      component: () => import('./Recommend.vue'),
      name: '2019CQYFJ',
      meta: {
        title: '重庆药房100强品牌推介活动',
      },
    },
  ],
};
